// Montserrat for the pages that keep the old look (Classic and v2 admin
// chrome, portal, login, signup, privacy, terms, /calendar, /audio/:id): the
// global MUI theme in App.js and index.css use it. The public v4 pages
// (html.v4) never use it, so it is not loaded there.
//
// The link is added by script, so it never blocks the first paint (a
// stylesheet created by the parser in <head> would). It is added once, the
// first time <html> is without the "v4" class: on start, or when the visitor
// navigates from a v4 page to an old-look page (PublicLayout removes the
// class when it unmounts).

export const LEGACY_FONT_ID = "legacy-font-montserrat";
export const LEGACY_FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap";

const isV4 = (doc) => Boolean(doc?.documentElement?.classList?.contains?.("v4"));

export function ensureLegacyFont(doc = typeof document !== "undefined" ? document : null) {
  if (!doc?.head) return null;
  const found = doc.getElementById?.(LEGACY_FONT_ID);
  if (found) return found;
  const link = doc.createElement("link");
  link.id = LEGACY_FONT_ID;
  link.rel = "stylesheet";
  link.href = LEGACY_FONT_HREF;
  doc.head.appendChild(link);
  return link;
}

// Returns a stop function (used by the tests).
export function watchLegacyFont(
  doc = typeof document !== "undefined" ? document : null,
  Observer = typeof MutationObserver !== "undefined" ? MutationObserver : null
) {
  const html = doc?.documentElement;
  if (!html) return () => {};
  if (!isV4(doc)) {
    ensureLegacyFont(doc);
    return () => {};
  }
  if (!Observer) return () => {};
  const observer = new Observer(() => {
    if (isV4(doc)) return;
    ensureLegacyFont(doc);
    observer.disconnect();
  });
  observer.observe(html, { attributes: true, attributeFilter: ["class"] });
  return () => observer.disconnect();
}
